import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Preloader from '../Preloader/Preloader'
import { brandLoginUrl, brandUrl } from '../../common/brand-login'

/** Leaves for `to` on another origin, replacing this entry so Back skips it. */
const BrandRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to)
  }, [to])

  return <Preloader />
}

/** `/login?utm=…` outside local dev: brand's login, same destination. */
export const BrandLoginForward = () => {
  const { search } = useLocation()
  return <BrandRedirect to={brandLoginUrl(new URLSearchParams(search).get('utm'))} />
}

/** `/e3ud0s` outside local dev: brand's promo page grants the free month now. */
export const BrandPromoForward = () => {
  const { search } = useLocation()
  return <BrandRedirect to={brandUrl(`/e3ud0s${search}`)} />
}

export default BrandRedirect
